export default __webpack_public_path__ + "images/public/images/acm-facade.jpg";